const aboutUs = {
  title: 'About | italist, ALWAYS LIKE A SALE',
  description:
    'Shop at italist 1,000 luxury international fashion designers from exclusively the best Italian stores. The same high-quality products up to 40% cheaper',
};

export default aboutUs;
